import { Link } from 'react-router-dom';
import { TypewriterText } from '../hooks/useTypewriter';

export default function Info() {
  return (
    <div className="min-h-screen bg-black py-12 lg:py-20 px-6 lg:px-8 page-wrapper" data-testid="info-page">
      <div className="max-w-2xl mx-auto space-y-12">
        <header>
          <h1 className="text-3xl lg:text-4xl font-bold text-white lowercase mb-2"><TypewriterText text="info" speed={80} startDelay={150} /></h1>
          <p className="text-[#555555] lowercase text-sm">miscellany.</p>
        </header>

        <section>
          <h2 className="text-white lowercase mb-4 text-base">legal</h2>
          <ul className="space-y-1.5 text-sm">
            <li><a href="mailto:james.blight64@gmail.com" className="text-[#888888] hover:text-white transition-colors lowercase">contact</a></li>
            <li><span className="text-[#555555] lowercase">license · MIT (soma runtime)</span></li>
            <li><span className="text-[#555555] lowercase">checkpoints are the property of their uploaders</span></li>
          </ul>
        </section>

        <section>
          <h2 className="text-white lowercase mb-4 text-base">for agents</h2>
          <ul className="space-y-1.5 text-sm">
            <li><a href="/llms.txt" className="text-[#888888] hover:text-white transition-colors lowercase">llms.txt</a> <span className="text-[#444444]">— llmstxt.org handshake</span></li>
            <li><a href="/api/manifest.json" className="text-[#888888] hover:text-white transition-colors lowercase">manifest</a> <span className="text-[#444444]">— full agent api</span></li>
            <li><a href="/api/site-info" className="text-[#888888] hover:text-white transition-colors lowercase">site-info</a></li>
            <li><a href="/sitemap.xml" className="text-[#888888] hover:text-white transition-colors lowercase">sitemap</a></li>
          </ul>
        </section>

        <section>
          <h2 className="text-white lowercase mb-4 text-base">seo not for humans</h2>
          <ul className="space-y-1.5 text-sm">
            <li>
              <Link to="/blog" className="text-[#888888] hover:text-white transition-colors lowercase" data-testid="info-blog-link">
                log
              </Link>
              <span className="text-[#444444]"> — chronological notes, crawlable</span>
            </li>
          </ul>
        </section>

        <section className="pt-4">
          <p className="text-[#333333] lowercase text-xs">
            <Link to="/" className="hover:text-white transition-colors">← home</Link>
          </p>
        </section>
      </div>
    </div>
  );
}
